import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const { t, i18n } = useTranslation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const changeLanguage = (lng: string) => {
    i18n.changeLanguage(lng);
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-black/80 backdrop-blur-xl shadow-lg' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-2">
            <div className="w-10 h-10 bg-gradient-to-br from-emerald-400 to-teal-500 rounded-lg flex items-center justify-center">
              <i className="ri-shield-check-line text-xl text-white"></i>
            </div>
            <span className="text-2xl font-bold bg-gradient-to-r from-emerald-400 to-teal-400 bg-clip-text text-transparent">
              ZK FACE
            </span>
          </div>

          <div className="hidden md:flex items-center space-x-8">
            <a href="#solution" className="text-gray-300 hover:text-emerald-400 transition-colors whitespace-nowrap">
              {t('nav.features')}
            </a>
            <a href="#how-it-works" className="text-gray-300 hover:text-emerald-400 transition-colors whitespace-nowrap">
              {t('nav.technology')}
            </a>
            <a href="#use-cases" className="text-gray-300 hover:text-emerald-400 transition-colors whitespace-nowrap">
              {t('nav.useCases')}
            </a>
            <a href="#contact" className="text-gray-300 hover:text-emerald-400 transition-colors whitespace-nowrap">
              {t('nav.contact')}
            </a>
            
            <div className="flex items-center space-x-2 ml-4">
              <button
                onClick={() => changeLanguage('ko')}
                className={`px-3 py-1 rounded-md transition-colors whitespace-nowrap ${
                  i18n.language === 'ko' ? 'bg-emerald-500 text-white' : 'text-gray-400 hover:text-white'
                }`}
              >
                한국어
              </button>
              <button
                onClick={() => changeLanguage('en')}
                className={`px-3 py-1 rounded-md transition-colors whitespace-nowrap ${
                  i18n.language === 'en' ? 'bg-emerald-500 text-white' : 'text-gray-400 hover:text-white'
                }`}
              >
                EN
              </button>
              <button
                onClick={() => changeLanguage('ja')}
                className={`px-3 py-1 rounded-md transition-colors whitespace-nowrap ${
                  i18n.language === 'ja' ? 'bg-emerald-500 text-white' : 'text-gray-400 hover:text-white'
                }`}
              >
                日本語
              </button>
              <button
                onClick={() => changeLanguage('zh')}
                className={`px-3 py-1 rounded-md transition-colors whitespace-nowrap ${
                  i18n.language === 'zh' ? 'bg-emerald-500 text-white' : 'text-gray-400 hover:text-white'
                }`}
              >
                中文
              </button>
            </div>
          </div>
        </div>
      </div>
    </nav>
  );
}
